<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>账号</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">渠道账号</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="
        !hideInAddShow && !hideInUserEdit && !hideInDetail && !hideInBatchPro
      "
    >
      <section class="searchBox">
        <!-- <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span> -->
        <!-- <span>
          <a-button
            type="primary"
            icon="plus"
            @click="hideInBatchPro = !hideInBatchPro"
            >批量关联项目</a-button
          >
        </span> -->
        <span>
          <label>状态：</label>
          <a-radio-group v-model="job_status">
            <a-radio :value="1">在职</a-radio>
            <a-radio :value="2">离职</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>公司：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="请选择公司"
            style="width: 200px"
            v-model="resume_third_part_id"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in thirdList"
              :key="i"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>岗位：</label>
          <a-select
            mode="multiple"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择岗位"
            style="width: 150px"
            v-model="role_ids"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in roleList"
              :key="i"
              >{{ item.role_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            v-model="query_field"
            placeholder="请输入姓名|手机号"
            style="width: 150px"
          />
        </span>
        <span>
          <a-button style="margin-right: 10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <!-- <td></td> -->
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                <p v-show="item.type == 1">{{ item.name }}</p>
                <p v-show="item.type == 2">个人</p>
              </td>
              <td>
                <p v-show="item.job_status == 1">在职</p>
                <p v-show="item.job_status == 2">离职</p>
                <p v-show="item.job_status == 0">未知</p>
              </td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td>
                <span v-for="(element, k) in item.role_info" :key="k">
                  <span v-show="k > 0">&nbsp;|&nbsp;</span>
                  <span>{{ element.role_name }}</span>
                </span>
              </td>
              <td>
                {{ item.entry_info.length }}
              </td>
              <td style="width: 35%">
                <span
                  v-show="item.entry_info != ''"
                  v-for="(element, j) in item.entry_info"
                  :key="j"
                >
                  <span v-show="j != 0 && j > 0 && j < 7">&nbsp;|&nbsp;</span>
                  <span v-show="j < 7">{{ element.project_name }}</span>
                </span>
                <span v-show="item.entry_info.length >= 7">...</span>
                <span v-show="item.entry_info == ''">---</span>
              </td>
              <td class="operation">
                <a
                  style="color: #67c23a"
                  v-show="item.type == 1"
                  @click="edit(item)"
                  >编辑</a
                >
                <a @click="detailPage(item)">详情</a>
                <a style="color:#F56C6C" @click="onDimission(item)">离职</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 编辑 -->
    <channelAccountEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
    <!-- 详情 -->
    <channelAccountDetails
      v-show="hideInDetail"
      :detail="detail"
      v-on:hideInDetailPage="hideInDetailPage"
    />
    <!-- 详情 end -->
    <!-- 批量关联项目 -->
    <batchPro v-show="hideInBatchPro" />
    <!-- 批量关联项目 end -->
    <!-- 离职 -->
    <aside class="dialogsBox" v-show="showIsDimission">
      <div>
        <h3>离职</h3>
        <a class="close" @click="showIsDimission = false">
          <a-icon style="color:#666" type="close-circle" />
        </a>
        <ul v-if="dimissionDetail != ''">
          <li>
            <label>姓名：</label>
            <p>{{ dimissionDetail.user_name }}</p>
          </li>
          <li>
            <label>入职日期：</label>
            <p>{{ dimissionDetail.entry_time.substring(0, 10) }}</p>
          </li>
          <li>
            <label><i>*</i>离职日期：</label>
            <a-date-picker v-model="dateVal" @change="changeDimission" />
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitDimission">
            提交
          </a-button>
        </div>
      </div>
    </aside>
    <!-- 离职 end -->
  </div>
</template>
<script>
import axios from "axios";
import channelAccountEdit from "@/components/resume/channelAccountEdit"; //编辑用户
import channelAccountDetails from "@/components/resume/channelAccountDetails"; //详情
import batchPro from "@/components/account/batchPro";
export default {
  components: {
    channelAccountEdit,
    channelAccountDetails,
    batchPro
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: [
        "类型",
        "状态",
        "姓名",
        "手机号",
        "岗位",
        "项目数量",
        "关联项目",
        "操作"
      ],
      employee_type: -1,
      hideInDetail: false,
      detail: {},
      thirdList: [],
      hideInBatchPro: false,
      resume_third_part_id: "",
      dimissionDetail: "",
      showIsDimission: false,
      dateVal: null,
      leave_time: "",
      role_ids: [],
      roleList: [],
      job_status: "",
      type: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getCompany(); //获取三方公司
    this.getRole(); //获取岗位
  },
  methods: {
    submitDimission() {
      if (this.leave_time != "") {
        this.showIsDimission = false;
        let url = this.httpsBasic.url + this.httpsBasic.user + "User/userLeave";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.dimissionDetail.id,
          leave_time: this.leave_time
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.dateVal = null;
            this.reload();
            this.$message.success("提交成功");
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.error("标记*为必填项");
      }
    },
    changeDimission(date, dateString) {
      this.leave_time = dateString;
    },
    onDimission(item) {
      this.showIsDimission = true;
      this.dimissionDetail = item;
    },
    getRole() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000,
        role_type: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.roleList = res.data.data.data;
          // console.log(this.roleList);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getCompany() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    detailPage(item) {
      this.detail = item;
      this.hideInDetail = true;
    },
    hideInDetailPage() {
      this.hideInDetail = false;
    },
    onReset() {
      this.query_field = "";
      this.job_status = "";
      this.resume_third_part_id = "";
      this.role_ids = [];
      this.type = "";
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
      this.hideInDetail = false;
      this.hideInBatchPro = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/employeeChannelList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          role_ids: JSON.stringify(this.role_ids),
          type: this.type,
          job_status: this.job_status,
          resume_third_part_id: this.resume_third_part_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    padding: 10px 2%;
    padding-bottom: 0;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 12px;
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
